module.exports = function () {
  var html = "\n    <div class=\"movemenu hide-scrollbar\">\n    </div>\n  ";
  return html;
};